import gql from 'graphql-tag'

import { IContentFeed } from '../queries/getContentFeeds'

export interface ISetContentFeedTopicsVariables {
  contentFeedId: string
  topicIds: string[]
}

export interface ISetContentFeedTopicsResponse {
  setContentFeedTopics: IContentFeed
}

/**
 * Replaces the feed's whole topic set, so send the full list rather than a
 * delta. An empty list is allowed -- that is what the boosts-only hero feed is.
 */
export const setContentFeedTopicsMutation = gql`
  mutation setContentFeedTopics(
    $contentFeedId: String!
    $topicIds: [String!]!
  ) {
    setContentFeedTopics(contentFeedId: $contentFeedId, topicIds: $topicIds) {
      id
      topics {
        id
        name
      }
    }
  }
`

export default setContentFeedTopicsMutation
